module.exports = __webpack_public_path__ + "static/media/video-call.fb3e6bda.svg";